var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title-bar',{attrs:{"title-stack":_vm.titleStack}}),_c('hero-bar',[_vm._v(" Categories "),_c('router-link',{staticClass:"button",attrs:{"slot":"right","to":{ name: 'category.new' }},slot:"right"},[_vm._v(" New Category ")])],1),_c('section',{staticClass:"section is-main-section"},[_c('category-table',{attrs:{"checkable":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }